import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: 'Как быстро я получу ответ на свой вопрос?',
      answer: 'Мы стремимся отвечать на все обращения в течение 2 часов в рабочее время. Для срочных вопросов рекомендуем использовать живой чат или телефон.'
    },
    {
      question: 'Какие языки поддерживает служба поддержки?',
      answer: 'Наша команда поддержки работает на русском, казахском и английском языках. Для других языков мы можем организовать перевод.'
    },
    {
      question: 'Можно ли получить техническую консультацию по интеграции?',
      answer: 'Да, наши технические специалисты готовы помочь с интеграцией API, настройкой системы и решением технических задач. Свяжитесь с нами через форму или чат.'
    },
    {
      question: 'Предоставляете ли вы обучение для команды?',
      answer: 'Да, мы предлагаем индивидуальное обучение, групповые тренинги и регулярные вебинары. Можем организовать выездное обучение в вашем офисе.'
    },
    {
      question: 'Как получить доступ к документации API?',
      answer: 'Полная документация API доступна в разделе "Центр ресурсов". Для расширенного доступа или специальной документации свяжитесь с нашей технической поддержкой.'
    },
    {
      question: 'Работает ли поддержка в выходные дни?',
      answer: 'Базовая поддержка доступна 24/7 через чат. Специалисты технической поддержки работают с понедельника по пятницу с 9:00 до 18:00 (GMT+6).'
    }
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-16 lg:py-24 bg-background">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto text-center mb-12">
          <h2 className="text-3xl lg:text-5xl font-headline font-bold text-foreground mb-4">
            Часто задаваемые вопросы
          </h2>
          <p className="text-lg text-muted-foreground">
            Ответы на популярные вопросы о нашей службе поддержки
          </p>
        </div>

        <div className="max-w-4xl mx-auto space-y-4">
          {faqs?.map((faq, index) => (
            <div
              key={index}
              className="bg-card border border-border rounded-xl overflow-hidden hover:shadow-lg transition-all duration-300"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full px-6 py-5 flex items-center justify-between text-left hover:bg-muted/30 transition-colors duration-200"
              >
                <span className="text-lg font-semibold text-foreground pr-4">
                  {faq?.question}
                </span>
                <Icon
                  name={openIndex === index ? 'ChevronUp' : 'ChevronDown'}
                  size={24}
                  className="flex-shrink-0 text-accent"
                />
              </button>
              
              {openIndex === index && (
                <div className="px-6 pb-5 animate-in slide-in-from-top duration-200">
                  <p className="text-muted-foreground leading-relaxed">
                    {faq?.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-12 max-w-4xl mx-auto bg-gradient-to-br from-accent/10 to-primary/10 border border-accent/20 rounded-2xl p-8">
          <div className="text-center">
            <h3 className="text-2xl font-headline font-bold text-foreground mb-3">
              Не нашли ответ на свой вопрос?
            </h3>
            <p className="text-muted-foreground mb-6">
              Наша команда поддержки готова помочь вам 24/7
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <a
                href="https://wa.me/77476660065"
                target="_blank"
                rel="noopener noreferrer"
                className="px-6 py-3 bg-accent text-accent-foreground rounded-lg font-medium hover:bg-accent/90 transition-colors duration-200 flex items-center space-x-2"
              >
                <Icon name="MessageSquare" size={20} />
                <span>Начать чат</span>
              </a>
              <a
                href="mailto:info@ai.jetu.pro"
                className="px-6 py-3 bg-card border border-border text-foreground rounded-lg font-medium hover:bg-muted transition-colors duration-200 flex items-center space-x-2"
              >
                <Icon name="Mail" size={20} />
                <span>Написать письмо</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;